import {
  PopoverContent,
  PopoverTrigger,
  Popover as ShadCnPopover
} from '@/ui/Shadcn/popover'

import { twMerge } from 'tailwind-merge'

function Popover({
  children,
  button,
  className,
  side,
  triggerClassName,
  ...props
}: {
  children: React.ReactNode
  button: React.ReactNode
  className?: string
  side?: 'top' | 'bottom' | 'left' | 'right'
  open?: boolean
  onOpenChange?: (open: boolean) => void
  triggerClassName?: string
  props?: React.ComponentProps<typeof ShadCnPopover>
}) {
  return (
    <ShadCnPopover {...props}>
      <PopoverTrigger asChild className={triggerClassName}>
        {button}
      </PopoverTrigger>
      <PopoverContent side={side} className={twMerge('w-80', className)}>
        {children}
      </PopoverContent>
    </ShadCnPopover>
  )
}

Popover.displayName = 'Popover'

export default Popover
